<template>
  <div class="announcement-bar text-center">
    <component
      :is="componentType"
      class="announcement-bar__wrapper"
      :href="announcementLink"
    >
      <div class="container">
        <div
          class="announcement-bar__message"
          v-html="message"
        />
      </div>
    </component>
  </div>
</template>
<script>

/**
 * Component: Announcement Bar
 * ------------------------------------------------------------------------------
 * @param {String} message - Text displayed on the announcement banner.
 * @param {String} announcementLink - The link to which announcement bar leads to.
 */

export default {
  name: 'AnnouncementBar',

  props: {
    message: {
      type: String,
      default: '',
    },
    announcementLink: {
      type: String,
      default: '',
    },
  },

  computed: {

    /**
     * Calculate the type of announcement text wrapper.
     * - Wrap in `a` link tag if the URL is specified, otherwise a regular `div`
     * @returns {String}
     */
    componentType() {
      return this.announcementLink ? 'a' : 'div'
    },
  },

}
</script>

<style src="./announcement-bar.scss" lang="scss"></style>
